
<div class="stepper-accordion-v">
  <!-- Header section -->
  <div class="stepper-accordion-v__header" v-if="title">
    <v-btn
      icon
      class="stepper-accordion-v__back-btn"
      @click="$emit('back')"
      v-if="showBackButton"
    >
      <v-icon>mdi-chevron-left</v-icon>
    </v-btn>
    <!-- <h3 class="stepper-accordion-v__title">{{ title }}</h3> -->
  </div>

  <!-- Responsive Grid Container -->
  <v-container fluid class="stepper-accordion-v__container px-0 overflow-hidden">
    <v-row justify="center">
      <v-col
        cols="12"
        md="12"
        lg="12"
        xl="8"
        class="stepper-accordion-v__col"
      >
        <!-- Vuetify V-Stepper in vertical mode -->
        <v-stepper
          v-model="currentStep"
          vertical
          class="stepper-accordion-v__stepper"
          elevation="0"
        >
    <template v-for="(step, index) in steps">
      <v-stepper-step
        :key="`step-${index}`"
        :step="index + 1"
        :complete="isStepComplete(index)"
        :editable="!step.disabled"
        :class="{ 'stepper-accordion-v__step--disabled': step.disabled }"
        :color="stepperColors.primary"
        @click="handleStepClick(index)"
      >
        <div class="stepper-accordion-v__step-label">
          <h3 class="stepper-accordion-v__step-title">{{ step.title }}</h3>
          <div class="stepper-accordion-v__step-subtitle" v-if="step.subtitle">{{ step.subtitle }}</div>
          <div class="stepper-accordion-v__disabled-reason" v-if="step.disabled && step.disabledReason">{{ step.disabledReason }}</div>
        </div>
        <div class="stepper-accordion-v__step-check" v-if="isStepComplete(index)">
          <v-icon color="#16a34a" size="24">mdi-check</v-icon>
        </div>
      </v-stepper-step>

      <v-stepper-content
        :key="`content-${index}`"
        :step="index + 1"
        class="stepper-accordion-v__content"
      >
        <div class="stepper-accordion-v__step-content">
          <slot :name="`step-${index}`" :step="step" :index="index">
            <div class="stepper-accordion-v__default-content">
              {{ step.content }}
            </div>
          </slot>
        </div>
      </v-stepper-content>
    </template>
        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

  <!-- Actions section -->
  <div class="stepper-accordion-v__actions" v-if="showActions">
    <v-btn
      outlined
      class="stepper-accordion-v__action-btn"
      :disabled="!canGoPrevious"
      @click="$emit('previous')"
    >
      Previous
    </v-btn>
    <v-btn
      class="stepper-accordion-v__action-btn stepper-accordion-v__action-btn--primary"
      :disabled="!canGoNext"
      @click="$emit('next')"
    >
      Next
    </v-btn>
  </div>
</div>
